import { plainToClass } from 'class-transformer'
import { validate } from 'class-validator'
import { GetEventDTO } from '../../dto/events'
import { Politician } from '../../entity'
import { store } from '../../store'

export const getEvent = async ( id: number | null ) => {

    let body, response

    try {

        response = await fetch( `${ process.env.REACT_APP_API_ORIGIN }/1.0.0/cms/events/${ id }`, {
            headers: {
                'Authorization': 'Bearer ' + store.getState().session.token,
                'Content-Type': 'application/json'
            },
            method: 'get'
        } )

    } catch ( exception ) {

        store.dispatch( { type: 'GET_EVENT_TIMEOUT' } )
        return

    }

    if ( response.status === 401 ) {

        store.dispatch( { type: 'GET_EVENT_UNAUTHORIZED' } )
        return

    }

    if ( response.status !== 200 ) {

        store.dispatch( { type: 'GET_EVENT_UNEXPECTEDRESPONSE' } )
        return

    }

    try {

        body = plainToClass( GetEventDTO, JSON.parse( await response.text() ) )

    } catch ( exception ) {

        store.dispatch( { type: 'GET_EVENT_INVALIDJSON' } )
        return

    }

    if ( ( await validate( body ) ).length > 0 ) {

        store.dispatch( { type: 'GET_EVENT_INVALIDRESPONSE' } )
        return

    }

    store.dispatch( { type: 'GET_EVENT_OK', event: body.event } )
    store.dispatch( { type: 'EVENT_SET_POLITICIANS', politicians: body.event.hostPoliticians } )

}
